import React from 'react';
import { Link } from 'react-router-dom';
import * as PermissionsConstants from "../../const/constants.js";
import data from "../../assets/apiRoutes.json";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import apiRoutes from "../../assets/apiRoutes.json";
import axios from "axios";
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import { Button } from 'devextreme-react/button';

export const fetchTransactionData = (searchQuery, accessToken, selectedTab, transactionFrom
  , transactionTo, poNumber, tDateTo, tDateFrom,
  sDateTo, sDateFrom,status=null) => {
  const resultData = createStore({
    key: 'rowid',
    loadParams:
    {
      transactionType: function () {
        return selectedTab;
      },
      transactionnumberfrom: function () {
        return transactionFrom??"";
      },
      transactionnumberto: function () {
        return transactionTo??"";
      },
      ponumber: function () {
        return poNumber??"";
      },
      transactionDatefrom: function () {
        return tDateFrom??"";
      },
      shippingdatefrom: function () {
        return sDateFrom??"";
      },
      transactionDateto: function () {
        return tDateTo??"";
      },
      shippingdateto: function () {
        return sDateTo??"";
      },
      shippernameto: function () {
        return searchQuery?.shippernameto??"";
      },
      status: function () {
        return status??"";
      },
      stage: function () {
        return selectedTab==="Quote"?"Q":"P";
      },
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${data.OM.SearchTransaction}`,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      };
    },
  });
  return resultData;
}
export const fetchProfileLookupData = async (kValue, lookupType, accessToken) => {
  var resultSet = (new DataSource({
    store: new CustomStore({
      key: 'rowid',
      load: async function (loadOptions) {
        const searchValue = loadOptions.searchValue || kValue;
        let request = {
          identityIdFrom: searchValue,
          code: searchValue,
          lookupType: lookupType,
          IsAutoComplete:true,
        };
        return await axios.post(
          `${window._env_.REACT_APP_APIS}/${apiRoutes.OM.SearchProfileLookup}`,
          request,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
          .then(response => response.data.lookups)
          .catch(error => {
            console.error('Error fetching data:', error);
            return [];
          });
      },
      byKey: async function (key) {
        let request = {
          identityIdFrom: kValue,
          code: kValue,
          lookupType: lookupType,
          isAutoComplete: true,
        };
        return await axios.post(
          `${window._env_.REACT_APP_APIS}/${apiRoutes.OM.SearchProfileLookup}`,
          request,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
          .then(response => response.data.lookups)
          .catch(error => {
            console.error('Error fetching data:', error);
            return [];
          });
      }
    })
  }))
  return resultSet;
}
export const fetchLookupData = async (kValue, lookupType, accessToken) => {
  var resultSet = (new DataSource({
    store: new CustomStore({
      key: 'rowid',
      load: async function (loadOptions) {

        const searchValue = loadOptions.searchValue || kValue;
        let request = {
          identityIdFrom: searchValue,
          code: searchValue,
          lookupType: lookupType,
          IsAutoComplete:true,
        };
        return await axios.post(
          `${window._env_.REACT_APP_APIS}/${apiRoutes.Receipt.SearchLookup}`,
          request,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
          .then(response => response.data.lookups)
          .catch(error => {
            console.error('Error fetching data:', error);
            return [];
          });
      },
      byKey: async function (key) {
        let request = {
          identityIdFrom: kValue,
          code: kValue,
          lookupType: lookupType,
          isAutoComplete: true,
        };
        return await axios.post(
          `${window._env_.REACT_APP_APIS}/${apiRoutes.Receipt.SearchLookup}`,
          request,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
          .then(response => response.data.lookups)
          .catch(error => {
            console.error('Error fetching data:', error);
            return [];
          });
      }
    })
  }))
  return resultSet;
}
export const fetchTransactioDetailData = (accessToken, selectedTab,headerRowId) => {
  const resultData = createStore({
    key: 'key',
    loadParams:
    {
      headerRowId: function () {
        return headerRowId;
      }
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${data.OM.GetDetailItems}`,
    updateUrl: `${window._env_.REACT_APP_APIS}/${data.OM.AddSelectedItems}`,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
        headerId: headerRowId,
      };
    },
    onModified: (method, ajaxOptions) => {
        notify(
            {
                message: 'Record has been added successfully.',
                width: 100,
            },
            'success',
            3000,
        );
    }
  });
  return resultData;
}
export const getUrlForButton = (selectedTab, permissions, mode) => {
  const canCreateQuote = permissions.OM?.includes(PermissionsConstants.OMCreateQuoteRole);
  const canCreateOrder = permissions.OM?.includes(PermissionsConstants.OMCreateOrderRole);
  const canUpdateQuote = permissions.OM?.includes(PermissionsConstants.OMUpdateQuoteeRole);
  const canUpdateOrder = permissions.OM?.includes(PermissionsConstants.OMUpdateOrderRole);
  const canReadQuote = permissions.OM?.includes(PermissionsConstants.OMReadQuoteRole);
  const canUReadOrder = permissions.OM?.includes(PermissionsConstants.OMReadOrderRole);
  const tabQuote = "Quote";
  const tabOrder = "Order";
  const tabHistory = "History";

  if (mode === "create") {
    if (selectedTab === tabQuote && canCreateQuote) {
      return "/om/transaction/create-transaction";
    } else if (selectedTab === tabOrder && canCreateOrder) {
      return "/om/transaction/create-transaction";
    }
  } else if (mode === "edit") {
    if (selectedTab === tabQuote && canUpdateQuote) {
      return "/om/transaction/change-transaction";
    } else if (selectedTab === tabOrder && canUpdateOrder) {
      return "/om/transaction/change-transaction";
    }
  } else if (mode === "view") {
    if (selectedTab === tabQuote && canReadQuote) {
      return "/om/transaction/view-transaction";
    } else if (selectedTab === tabOrder && canUReadOrder) {
      return "/om/transaction/view-transaction";
    }
    else if (selectedTab === tabHistory){
      return "/om/history/view-history";
    }
  }
  return null;
};
export const RenderButtonForGrid = (selectedTab, permissions, mode) => {
  const buttonUrl = getUrlForButton(selectedTab, permissions, mode);
  if (buttonUrl && mode == "create") {
    return (
      <div>
        
        <Link to={buttonUrl}>
        <Button className="gridTopButton"  text="Create" type="default"/>
        </Link>
      </div>
    );
  } else {
    return (
      <div>
       <Button className="gridTopButton"  text="Create" type="default" disabled={true}/>
      </div>
    );
  }
};